import React from "react";
import { motion } from "framer-motion";
import { Award } from "lucide-react";
import { ACHIEVEMENTS } from "../data/portfolioData";

export default function Achievements() {
  return (
    <section className="py-16 relative overflow-hidden bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-10 space-y-2">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-800 text-xs font-mono font-bold">
            <Award size={14} /> PROVEN TRACK RECORD
          </div>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
            Key Operational <span className="gradient-text-indigo">Impact & Metrics</span>
          </h2>
        </div>

        {/* Counter Cards Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {ACHIEVEMENTS.map((item, idx) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="p-6 rounded-3xl bg-slate-50 border border-slate-200 text-center space-y-2 hover:border-indigo-400 transition-all shadow-sm hover:shadow-md"
            >
              <div className="text-3xl sm:text-4xl font-black text-slate-900">
                <span className="gradient-text-indigo">
                  {item.value}
                </span>
                <span className="text-indigo-700 text-xl font-bold">{item.suffix}</span>
              </div>
              <div className="text-xs font-mono font-bold text-slate-700 uppercase tracking-wider">
                {item.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
